import React from 'react';
import { styled } from '@mui/material/styles';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';


const PREFIX = 'LinearProgressWithLabel';

const classes = {
  root: `${PREFIX}-root`,
  bar: `${PREFIX}-bar`
};

const StyledBox = styled(Box)({
  root: {
    height: '8px',
    borderRadius: 'var(--radius-full, 9999px);',
    backgroundColor: 'var(--Background-400, #4A4C51);',
  },
  bar: {
    borderRadius: 'var(--radius-full, 9999px);',
    background: 'var(--Gradient-1, linear-gradient(270deg, #4CC9F0 0.1%, #4895EF 48.44%, #4268ED 99.9%));',
  },
});


const StyledLinearProgress = LinearProgress;


export const LinearProgressWithLabel = (props: LinearProgressProps & { value: number }) => {
  return (
    <StyledBox display='flex' alignItems='center'>
      <Box width='100%' mr={1}>
        <StyledLinearProgress
          variant='determinate'
          {...props}
          classes={{
            root: classes.root,
            bar: classes.bar
          }} />
      </Box>
      <Box minWidth={35}>
        <Typography variant='body2' color='textSecondary'>{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </StyledBox>
  );
};


